__webpack_require__.p = "/reports-details-components-refactor/onboarding/";